import { SelectOptions } from '../../../../../../utils/types/react_select_types';

export const WORK_TYPES: SelectOptions[] = [
  {
    label: 'Permanent',
    value: 'Permanent',
  },
  {
    label: 'Part Time',
    value: 'Part Time',
  },
  {
    label: 'Casual',
    value: 'Casual',
  },
  {
    label: 'Contract',
    value: 'Contract',
  },
];
